// @flow
import { handleActions } from 'redux-actions';
import {
    SET_ALL_TASKS_COUNT,
    SET_MY_TASKS_COUNT,
    SET_ALL_COMMUNICATION_TASKS_COUNT,
    SET_MY_COMMUNICATION_TASKS_COUNT,
} from './constants';

export type State = {
    allTasksCount: number,
    myTasksCount: number,
    allCommunicationTasksCount: number,
    myCommunicationTasksCount: number,
};

const initialState: State = {
    allTasksCount: 0,
    myTasksCount: 0,
    allCommunicationTasksCount: 0,
    myCommunicationTasksCount: 0,
};

const reducer = handleActions({
    [SET_ALL_TASKS_COUNT]: (state: State, { payload }: {
        payload: {
            allTasksCount: number
        }
}) => ({ ...state, allTasksCount: payload }),
    [SET_ALL_COMMUNICATION_TASKS_COUNT]: (state: State, { payload }: {
        payload: {
            allCommunicationTasksCount: number
        }
}) => ({ ...state, allCommunicationTasksCount: payload }),
    [SET_MY_TASKS_COUNT]: (state: State, { payload }: {
        payload: {
            myTasksCount: number
        }
}) => ({ ...state, myTasksCount: payload }),
    [SET_MY_COMMUNICATION_TASKS_COUNT]: (state: State, { payload }: {
        payload: {
            myCommunicationTasksCount: number
        }
}) => ({ ...state, myCommunicationTasksCount: payload }),
}, initialState);

export default reducer;
